import { render, staticRenderFns } from "./CouponMy.vue?vue&type=template&id=e1c3fd34&scoped=true&"
import script from "./CouponMy.vue?vue&type=script&lang=js&"
export * from "./CouponMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c3fd34",
  null
  
)

export default component.exports